var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticStyle:{"overflow":"hidden"}},[_c('top-nav',{class:_vm.$route.name=='dashboard'?'dashboard-header':''})],1),_vm._v(" "),_c('div',{staticStyle:{"min-height":"400px","margin-top":"170px"}},[_c('router-view')],1),_vm._v(" "),_c('bottom-footer',{class:_vm.$route.name=='dashboard'?'dashboard-footer':''})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18f8bc66","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/home/index.vue
// module id = null
// module chunks = 